import { DateSelect } from '../../../../../DateTime'

import { ViewingFormSlotPickerDay } from './ViewingFormSlotPickerDay'

import * as styles from './ViewingFormSlotPickerCalendar.module.css'

function ViewingFormSlotPickerCalendar({ days, disabled, value, onChange }) {
  return (
    <DateSelect
      className={styles.ViewingFormSlotPickerCalendar}
      disabled={disabled}
      // DateSelect reads its month once on mount, so the instance follows the day.
      key={value?.getTime()}
      maxValue={days[days.length - 1]}
      minValue={days[0]}
      optionsProps={{ Item: ViewingFormSlotPickerDay, itemProps: { days } }}
      value={value}
      onChange={onChange}
    />
  )
}

export default ViewingFormSlotPickerCalendar
